export const copyOrderCheck = {
  success: 1,
  hasExistingCart: 2,
  hasBadData: 3,
  hasHasMissingFileVolCcn: 4,
};
